var mp = mp || {};

// FancyBox
//-----------------------------------------------------------------
mp.fancyBox = function() {
    var $trigger = $("[data-fancybox]");

    if (!$trigger.length) {
        return;
    }
    
    $trigger.fancybox({
        touch: true,
        infobar: false,
        buttons: [
            "close"
        ],
    });
};


// Tabs
//-----------------------------------------------------------------
mp.tabs = function() {
    var $element = $("[data-toggle-tab]");

    if (!$element.length) {
        return;
    }

    $(document).on('click', '[data-toggle-tab]', function(e){
        e.preventDefault();
        
        $target = $(this).data("toggle-tab");
        $('[data-toggle-tab], [data-toggle-content]').removeClass('active');

        $(this).addClass("active");
        $('[data-toggle-content="'+$target+'"]').addClass("active");
    })
};



// Toggle
//-----------------------------------------------------------------
mp.toggle = function() {
    var $element = $("[data-toggle]");

    if (!$element.length) {
        return;
    }

    $(document).on('click', '[data-toggle]', function(e){
        e.preventDefault();

        // OPEN ALL
        //$target = $(this).data("toggle");
        
        //$(this).toggleClass("active");
        //$('[data-toggle-content="'+$target+'"]').toggleClass("active");


        // OPEN ONE
        $already_active = $(this).hasClass("active");
        
        $target = $(this).data("toggle");
        $('[data-toggle], [data-toggle-content]').removeClass('active');

        if ($already_active == false) {
            $(this).addClass("active");
            $('[data-toggle-content="'+$target+'"]').addClass("active");
        }
    })

    $(document).on('click', '[data-close]', function(e){
        $('[data-toggle], [data-toggle-content]').removeClass('active');
    })

    $(document).on('click', '.projects--hero .pins', function(e){
        if ($(e.target).hasClass('pins')) {
            $('[data-toggle], [data-toggle-content]').removeClass('active');
        }
    })
};



// ScrollTo
//-----------------------------------------------------------------
mp.scrollTo = function() {
    var $trigger = $("[data-scroll]");

    if (!$trigger.length) {
        return;
    }


    $.extend($.scrollTo.defaults, {
        axis: 'y',
        duration: 800,
        offset: -70,
    });

    $trigger.on('click', function(e) {
        e.preventDefault();

        $target = $(this).attr("href");

        if ($target.length > 1) {
            $target = $target.replace("#", "");

            if ($target == "top") {
                $target = $("body");
            } else {
                $target = $("#st_"+$target);
            }
            
            $.scrollTo($target);
        }
    });
}



// Marquee
//-----------------------------------------------------------------
mp.marquee = function() {
    var $element = $(".marquee");

    if (!$element.length) {
        return;
    }

    $element

    $element.marquee({
        duration: 15000,
        gap: 1,
        delayBeforeStart: 0,
        direction: 'left',
        speed: 80,
        duplicated: true,
        startVisible: true
    });
}






$(document).ready(function (){
    mp.fancyBox();
    mp.tabs();
    mp.toggle();
    mp.scrollTo();
    mp.marquee();
});